import './index.scss'
import {ImgButton} from '../../components/core/button'
import {ButtonArrow, PageIsNotFound} from '../../icons'
import {useDispatch, useSelector} from 'react-redux'
import {useNavigate} from 'react-router-dom'
import AddResourceModal from '../../components/pages/resource/AddResourceModal'
import Footer from '../../components/layouts/footer'
import NotFound from '../resources/NotFound'
import {routes} from '../../routes'
import {ResponsivePageTitle} from '../../components/core/title'
import classNames from 'classnames'
import {setActivePopup} from '../../stores/popup'
import NavigationHelper from '../../utils/navigation'
import {useNamespaceTranslations} from '../../utils/hooks/useNamespacesTranslations'

const NotFoundPage = () => {
    const navigate = useNavigate()
    const text = useNamespaceTranslations('not-found')
    const modalTypes = useNamespaceTranslations('modals')
    const activePopup = useSelector(state => state.popup.activePopup)
    const isDarkMode = useSelector(state => state.sidebar.isDarkMode)
    const dispatch = useDispatch()

    const goToMainPage = () => {
        navigate(NavigationHelper.getLocalizedPath(routes.resources.paths))
    }
    return (
        <>
            <main className={classNames('main monitoring', {
                dark: isDarkMode
            })}>
                <ResponsivePageTitle/>
                <div className={classNames('not-found-container', {
                    dark: isDarkMode
                })}>
                    <div className="not-found-content">
                        <NotFound message={text.page_not_found} icon={<PageIsNotFound/>}/>
                        <ImgButton className="go-to-mainpage" onClick={goToMainPage}>
                            {text.go_to_mainpage}
                            <span><ButtonArrow/></span>
                        </ImgButton>
                    </div>
                </div>
                <Footer/>
            </main>
            {activePopup?.component === modalTypes.uptime_monitoring.addResource.component &&
                <AddResourceModal
                    closeModal={() => dispatch(setActivePopup(null))} isOpen={!!activePopup?.type}
                    title={activePopup.title} contentClassName="overflow-auto"/>
            }
        </>
    )
}

export default NotFoundPage
